import Fuse from 'fuse.js/dist/fuse.basic'
import {lib} from 'emojilib'
import map from 'lodash/map'
import slice from 'lodash/slice'

export const list = map(lib, (val, key) => ({...val, key}))

export const fuse = new Fuse(list, {
  keys: [
    {name: 'key', weight: 0.7},
    {name: 'keywords', weight: 0.3},
  ],
})

export function search(keyword, count) {
  const items = keyword ? map(fuse.search(keyword), 'item') : list
  return count ? slice(items, 0, count) : items
}
